// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let ReactContentLoader = require("react-content-loader").default;

function Callout__Skeleton(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(ReactContentLoader, {
      children: [
        JsxRuntime.jsx("rect", {
          height: "44",
          width: "44",
          rx: "5",
          ry: "5",
          x: "8",
          y: "0"
        }),
        JsxRuntime.jsx("rect", {
          height: "13",
          width: "400",
          rx: "4",
          ry: "4",
          x: "68",
          y: "4"
        }),
        JsxRuntime.jsx("rect", {
          height: "10",
          width: "250",
          rx: "3",
          ry: "3",
          x: "68",
          y: "30"
        })
      ],
      height: "43px",
      width: "100%"
    }),
    className: "border border-zinc-200 rounded-md bg-white p-4 flex"
  });
}

let make = Callout__Skeleton;

exports.make = make;
/* react/jsx-runtime Not a pure module */
